import { motion } from 'framer-motion';
import type { Identity } from '../types';

interface IdentityCardProps {
  identity: Identity;
  isSelected: boolean;
  onClick: () => void;
}

export function IdentityCard({ identity, isSelected, onClick }: IdentityCardProps): JSX.Element {
  return (
    <motion.button
      onClick={onClick}
      initial={false}
      animate={{
        scale: isSelected ? 1.02 : 1,
        opacity: isSelected ? 1 : 0.55,
      }}
      transition={{ type: 'spring', stiffness: 300, damping: 25 }}
      style={{
        minWidth: '150px',
        padding: '28px 20px',
        borderRadius: '16px',
        border: isSelected ? '1px solid rgba(0, 0, 0, 0.15)' : '1px solid rgba(0, 0, 0, 0.06)',
        backgroundColor: isSelected ? '#ffffff' : 'transparent',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        gap: '16px',
        cursor: 'pointer',
        scrollSnapAlign: 'center',
        WebkitTapHighlightColor: 'transparent',
        touchAction: 'manipulation',
        boxShadow: isSelected ? '0 4px 20px rgba(0,0,0,0.08)' : 'none',
      }}
    >
      <div
        style={{
          width: '44px',
          height: '44px',
          borderRadius: '12px',
          backgroundColor: isSelected ? 'rgba(0, 0, 0, 0.04)' : 'rgba(0, 0, 0, 0.02)',
          border: isSelected ? '1px solid rgba(0, 0, 0, 0.1)' : '1px solid rgba(0, 0, 0, 0.06)',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          fontSize: '11px',
          fontWeight: 600,
          color: isSelected ? '#1a1a1c' : '#a1a1a6',
          textTransform: 'uppercase',
          letterSpacing: '0.1em',
        }}
      >
        {identity.id.slice(0, 2)}
      </div>
      <span
        style={{
          fontSize: '15px',
          fontWeight: 500,
          color: isSelected ? '#1a1a1c' : '#6e6e73',
          letterSpacing: '0.02em',
        }}
      >
        {identity.name}
      </span>
    </motion.button>
  );
}
